module.exports = __webpack_public_path__ + "img/bf-bg-short.7684ab7e.png";